import styled from 'styled-components';
import { Stack } from '../../Stack';
import { AlertColours } from '../types';
import { theme } from '../../../theme';

export const AlertContainer = styled(Stack).attrs<{ colours: AlertColours }>({
  direction: 'horizontal',
  alignX: 'between',
  alignY: 'top',
  spacing: 0,
})<{
  colours: AlertColours;
}>`
  border: 1px solid ${({ colours: { primary } }) => primary};
  border-radius: ${theme.radius.base};

  background-color: ${({ colours: { background } }) => background};
`;
